import {RealtimeMessageType} from 'notebook/realtime/Constants';
import {entryUpdateMessageHandler} from 'notebook/realtime/messageHandlers/entryUpdateMessageHandler';
import {lockUpdateMessageHandler} from 'notebook/realtime/messageHandlers/lockUpdateMessageHandler';
import {tableApiPendingRowsUpdateMessageHandler} from 'notebook/realtime/messageHandlers/tableApiPendingRowsUpdateMessageHandler';
import {GetRealtimeMessageData, RealtimeMessage} from 'realtime/RealtimeChannel';

export interface DocumentUpdateMessageHandler<Name extends RealtimeMessageType> {
  active?: (fileId: string, data: GetRealtimeMessageData<Name>) => void;
  inactive?: (fileId: string, data: GetRealtimeMessageData<Name>) => void;
}

/**
 * Maps a message to its handler.
 */
export function messageRouter(fileId: string, type: 'active' | 'inactive'): (msg: RealtimeMessage) => void {
  return ({name, data}) => {
    const handler = getMessageHandler(name);
    if (handler[type]) {
      handler[type](fileId, data ?? {});
    }
  };
}

function getMessageHandler(type: RealtimeMessageType): DocumentUpdateMessageHandler<RealtimeMessageType> {
  switch (type) {
    case RealtimeMessageType.ENTRY_UPDATE:
      return entryUpdateMessageHandler;
    case RealtimeMessageType.LOCK_UPDATE:
      return lockUpdateMessageHandler;
    case RealtimeMessageType.TABLE_API_PENDING_ROWS_UPDATE:
      return tableApiPendingRowsUpdateMessageHandler;
    // Some messages are filtered out by this channel listener.
    default:
      return {};
  }
}
